"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../../../common/helpers/time");
var json_1 = require("../../../common/helpers/json");
var AdminCoursesCreateController = /** @class */ (function () {
    function AdminCoursesCreateController($state, $scope, UsersModel, CoursesModel, FlashService, ClassroomsModel, BatchCreateService, courseTypes, VueStoreFactory, UserService, LocationsModel) {
        var _this = this;
        this.$state = $state;
        this.$scope = $scope;
        this.UsersModel = UsersModel;
        this.LocationsModel = LocationsModel;
        this.VueStoreFactory = VueStoreFactory;
        this.CoursesModel = CoursesModel;
        this.FlashService = FlashService;
        this.ClassroomsModel = ClassroomsModel;
        this.BatchCreateService = BatchCreateService;
        this.courseTypes = courseTypes;
        this.locations = [];
        this.classrooms = [];
        this.instructors = [];
        this.submitted = false;
        this.submitSuccess = false;
        this.loading = true;
        this.busy = false;
        this.courseId = null;
        this.user = UserService.getCurrentUser();
        this.overrideInstructorSettings = "N";
        this.formData = {
            duration: {},
            number_of_seats: 20,
            school_id: this.user.school.id,
            date: new Date(),
            time: new Date(),
        };
        this.handleLocationChange = this.handleLocationChange.bind(this);
        this.handleLinkClick = this.handleLinkClick.bind(this);
        this.submit = this.submit.bind(this);
        this.setup()
            .then(function () {
            _this.loading = false;
            _this.busy = false;
            _this.$scope.$apply();
        })
            .catch(function (error) {
            console.error("Error in setup:", error);
            _this.loading = false;
            _this.busy = false;
            _this.$scope.$apply();
        });
    }
    AdminCoursesCreateController.prototype.setup = function () {
        return __awaiter(this, void 0, void 0, function () {
            var locations, storePolicies, policy, policyMeta, dur, classrooms, instructors;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.LocationsModel.getLocations()];
                    case 1:
                        locations = _a.sent();
                        storePolicies = this.VueStoreFactory.state.auth.policies.policies;
                        policy = storePolicies.find(function (p) { return p.name === "courses"; });
                        this.locations = locations;
                        this.policies = { courses: { id: policy.id, policymeta: {} } };
                        policyMeta = {};
                        policy.policymeta.forEach(function (meta) {
                            policyMeta[meta.meta_key] = (0, json_1.isJson)(meta.meta_value)
                                ? JSON.parse(meta.meta_value)
                                : meta.meta_value;
                        });
                        this.policies["courses"].policymeta = policyMeta;
                        this.formData.school_id = this.user.school.id;
                        if (this.policies.courses.policymeta.date === "today") {
                            this.formData.date = new Date();
                        }
                        if (this.policies.courses.policymeta.date === "+3 days") {
                            this.formData.date = (0, time_1.addDays)(new Date(), 3);
                        }
                        if (this.policies.courses.policymeta.date === "+7 days") {
                            this.formData.date = (0, time_1.addDays)(new Date(), 7);
                        }
                        this.formData.time = (0, time_1.timeStringToDate)(this.policies.courses.policymeta.time + ":00");
                        if (this.policies.courses.policymeta.minimum_session_length) {
                            dur = (0, time_1.minutesToHoursAndMinutes)(this.policies.courses.policymeta.minimum_session_length);
                            this.formData.duration.hours = dur.hours;
                            this.formData.duration.minutes = dur.minutes;
                        }
                        return [4 /*yield*/, this.getClassrooms(null, true, locations[0])];
                    case 2:
                        classrooms = _a.sent();
                        return [4 /*yield*/, this.getInstructors(null, true, locations[0])];
                    case 3:
                        instructors = _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AdminCoursesCreateController.prototype.batchCreate = function () {
        this.BatchCreateService.setCourse(this.formData);
        this.$state.go("drivecoach.admin.courses.batch");
    };
    AdminCoursesCreateController.prototype.getInstructors = function (name, all, location) {
        var _this = this;
        if (name === void 0) { name = null; }
        if (all === void 0) { all = false; }
        if (location === void 0) { location = null; }
        if (name === null && all === false) {
            return;
        }
        this.busy = true;
        var params = {
            location: { id: location.id },
            overrideInstructorSettings: this.overrideInstructorSettings,
        };
        return this.UsersModel.searchInstructors(params)
            .then(function (response) {
            _this.instructors = [{ id: 0, fullname: "None" }].concat(response.instructors);
            _this.busy = false;
            return response.instructors;
        })
            .catch(function (error) {
            _this.busy = false;
            return error;
        });
    };
    AdminCoursesCreateController.prototype.getClassrooms = function (name, all, location) {
        var _this = this;
        if (name === void 0) { name = null; }
        if (all === void 0) { all = false; }
        if (location === void 0) { location = null; }
        this.busy = true;
        var params = {
            location: { id: location.id },
        };
        return this.ClassroomsModel.search(params)
            .then(function (response) {
            _this.classrooms = response.classrooms;
            _this.busy = false;
            return response.classrooms;
        })
            .catch(function (error) {
            _this.busy = false;
            return error;
        });
    };
    AdminCoursesCreateController.prototype.handleLocationChange = function (location_id) {
        var location = this.locations.find(function (location) { return location.id == location_id; });
        this.getClassrooms(null, true, location);
        this.getInstructors(null, true, location);
    };
    AdminCoursesCreateController.prototype.handleLinkClick = function (data) {
        this.$state.go(data.destination, data.params);
    };
    AdminCoursesCreateController.prototype.submit = function (data) {
        var _this = this;
        this.submitSuccess = false;
        this.submitted = true;
        var payload = Object.assign({}, data);
        payload.classes = payload.classes.map(function (c) {
            if (c.instructor_id === 0) {
                delete c.instructor;
                delete c.instructor_id;
            }
            return c;
        });
        this.CoursesModel.create(payload)
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.submitted = false;
            _this.courseId = response.course.id;
            _this.$state.go("drivecoach.admin.courses.view", {
                courseId: _this.courseId,
            });
        })
            .catch(function (error) {
            _this.submitted = false;
        });
    };
    return AdminCoursesCreateController;
}());
AdminCoursesCreateController.$inject = [
    "$state",
    "$scope",
    "UsersModel",
    "CoursesModel",
    "FlashService",
    "ClassroomsModel",
    "BatchCreateService",
    "courseTypes",
    "VueStoreFactory",
    "UserService",
    "LocationsModel",
];
exports.default = AdminCoursesCreateController;
